import {
  Variant,
  enableBuyNowButton,
  updateFeaturesList,
} from './pdp-redesign/utils';
import {
  updateSummary,
  updateSummaryOnQuantityChange,
} from './pdp-redesign/variant-selection-summary';

import { addSupportForDisabledLinks } from './pdp-redesign/disabled-links';
import { initBuyButton } from './modules/buyNowButton';
import { initCheckboxModule } from './pdp-redesign/checkbox-buttons';
import { initProductImagesNavigation } from './pdp-redesign/product-images-navigation';
import { initRadioBoxModule } from './pdp-redesign/radio-buttons';
import initUpgradeablePetsModule from './modules/upgradeablePets';
import { initVariantOptionsValidation } from './pdp-redesign/variant-options-validation';
import { initVideoModule } from './pdp-redesign/product-videos';
import { notifyHandledException } from './utils/errorLogger';
import { toggleWaitlist } from './pdp-redesign/waitlist-form';
import { tooltip } from './pdp-redesign/tooltip';
import {
  updateVariantDiscountCode,
  updateVariantSavings,
} from './pdp-redesign/variant-discount-code';
import { updateVariantDisplayPrice } from './pdp-redesign/variant-display-prices';
import { initDrawerComponents } from './modules/drawer-component';
import { initAccordions } from './modules/pdp-accordions';
import { initSlickGallery } from './modules/slick-gallery-variant';
import { initSlickProductTastingGallery } from './modules/slick-product-tasting-gallery';
import { initPdpNavigation } from './modules/pdpNavigation';

const handleDiegoBreedReveal = (event: Event | KeyboardEvent): void => {
  if (
    (event.type === 'click' ||
      (event instanceof KeyboardEvent &&
        (event.code === 'Enter' || event.code === 'Space'))) &&
    event.target instanceof Element
  ) {
    event.preventDefault();

    //Target will be the button element
    const diegoBreed = event.target.parentElement;
    diegoBreed?.classList.add('revealed');
  }
};

const revealDiegoBreedButton = document.getElementById(
  'revealDiegoBreed--button'
);

revealDiegoBreedButton?.addEventListener('click', handleDiegoBreedReveal);
revealDiegoBreedButton?.addEventListener('keydown', handleDiegoBreedReveal);

function updateVariantDescription(
  descriptions: NodeListOf<Element>,
  variant: Variant
): void {
  if (descriptions.length === 0) {
    return;
  }

  descriptions.forEach((description) => {
    if (!(description instanceof HTMLElement)) {
      return;
    }

    description.style.display = 'none';
  });

  const description = document.querySelector(
    `.variant-description--${variant.id}`
  );

  if (description instanceof HTMLElement) {
    description.style.display = 'block';
  }
}

document.addEventListener('DOMContentLoaded', function () {
  initBuyButton();
  initPdpNavigation();
  initProductImagesNavigation();
  initVariantOptionsValidation();
  addSupportForDisabledLinks();
  initRadioBoxModule();
  initCheckboxModule();
  initVideoModule();

  initAccordions();

  initSlickGallery();
  initSlickProductTastingGallery();

  const updateBuyNowButtonHeapValueAttribute = (skuPrefix: string): void => {
    document
      .querySelectorAll('[data-heap-action="buy now"]')
      .forEach((item) => {
        if (item instanceof HTMLElement) {
          item.dataset.heapValue = skuPrefix.toLowerCase();
        }
      });
  };
  const updateAddToCartHeapValueAttribute = (
    container: JQuery,
    skuPrefix: string
  ): void => {
    container
      .find('[data-heap-action="add to cart"]')
      .each((_index, element) => {
        element.dataset.heapValue = skuPrefix.toLowerCase();
      });
  };

  const productContainer = jQuery('.product-template-has-variants');
  const descriptions = document.querySelectorAll('.variant-description');

  productContainer.on('variantChange', function (event) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const variant = event.variant as Variant | null;
    document.dispatchEvent(
      new CustomEvent('variant:change', {
        detail: {
          originalEvent: event,
          variant,
        },
        bubbles: true,
        cancelable: true,
      })
    );

    if (!variant) {
      return;
    }

    updateVariantSavings(variant);
    enableBuyNowButton(variant);
    updateVariantDescription(descriptions, variant);
    updateFeaturesList(variant, 'standard');
    updateFeaturesList(variant, 'health');

    const variantSkuPrefix = variant.sku.substring(0, 3);
    updateAddToCartHeapValueAttribute(productContainer, variantSkuPrefix);
    updateBuyNowButtonHeapValueAttribute(variantSkuPrefix);

    // The following is hack to fix an issue with how the debut theme JS updates the product images
    // on variant change. Since DNA kit is the default variant it does not update the image
    // and keeps displaying the default product image. This forces it to change the image
    // by triggering the variantImageChange event.
    if (variantSkuPrefix === 'DNA' && window.__IMAGE_GALLERY_VARIANT !== 'A') {
      $(this).trigger({
        type: 'variantImageChange',
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        variant,
      });
    }

    updateVariantDisplayPrice(variant);
    updateVariantDiscountCode(variant);
    toggleWaitlist(variant);
    updateSummary(variant);
  });

  updateSummaryOnQuantityChange();
  tooltip('.tooltip');
  initUpgradeablePetsModule().catch((error) => {
    notifyHandledException(error);
    // eslint-disable-next-line no-console
    console.error(error);
  });

  initDrawerComponents();
});
